export interface GeneralStats {
    subscriptions: number;
    enclosures: number;
    companies: number;
    events: number;
    subscribers: number;
    incidences?: number;
    eventSessionWithErrors: number;
}

export const getEmptyGeneralStats = (): GeneralStats => ({
    subscriptions: 0,
    enclosures: 0,
    companies: 0,
    events: 0,
    subscribers: 0,
    eventSessionWithErrors: 0,
});
